export default [
  {
    id: 'DEV716627',
    title: 'New Lead has been received',
    when: '2 hours ago',
    type: 'lead',
    to: '/leads'
  }
];
